import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.extend(relativeTime);
dayjs.extend(utc);

export const formatDate = (date: string | number | Date, format = 'DD/MM/YYYY') => {
  if (!date) return;

  return dayjs(date).format(format);
};

export const formatDateToStrings = (date: string) => {
  if (!date) return;

  return dayjs(date).format('DD [de] MMMM [de] YYYY [às] HH:mm');
};

export const timeSince = (date: string) => {
  if (!date) {
    return '-';
  }

  const dayjsDate = dayjs(date);
  const now = dayjs().utc();

  return `${dayjs(dayjsDate).from(now, true)} atrás`;
};

export const formatDateToRssFeed = (date: string) => {
  const weekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  if (!date) {
    return '-';
  }

  const dayjsDate = dayjs(date);

  return `${weekDays[dayjsDate.day()]}, ${dayjsDate.format(
    'DD MMM YYYY HH:mm:ss'
  )}`;
};
